module.exports = __webpack_public_path__ + "static/media/job-matcher-widget-preview.ed741e41.png";